/*
 * @Description: 危险区域流入商品信息
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-03 10:24:25
 * @LastEditTime: 2020-12-03 11:41:31
 */

import request from "_private/utils/request";

// 获取危险区域列表
export function fetchDangerAreaList() {
  return request({
    url: "/coldTrace/dangerTrace/regionTree",
    method: "get",
    headers: { type: "json" }
  });
}

// 获取危险区域商品流通信息列表
export function fetchDangerAreaTraceList(data) {
  return request({
    url: "/coldTrace/dangerTrace/dangerAreaTraceList",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 导出危险区域商品流通信息列表
export function exportDangerAreaTraceList(data) {
  return request({
    url: "/coldTrace/dangerTrace/exportDangerAreaTrace",
    method: "post",
    responseType: "blob",
    headers: { type: "json" },
    data
  });
}
